import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { extendedTestimonials, stats, testimonials } from '../data/offer';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-168" data-mp="3gqhw3medjbas">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-169" data-mp="3brdkyq7w33ht" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-170" data-mp="3qmkvwllr6xuk">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-4" data-id="element-171" data-mp="3lo067g44nwkd">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-172" data-mp="3vfdzv79ee25l">
              <p className="font-display text-4xl font-bold sm:text-5xl" data-id="element-173" data-mp="3vhqp85hhjeso">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-174" data-mp="daar9ck8380f">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-175" data-mp="1gepetnlohxv0">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-176" data-mp="1lb64im8j0ka7">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-177" data-mp="1qd56pssj5b5k" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-178" data-mp="292bu3t49qqxp">
                <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-179" data-mp="2e14zszdbddnb">
                  {initials}
                </div>
                <div data-id="element-180" data-mp="2n0s0fiy7yffb">
                  <h3 className="font-bold" data-id="element-181" data-mp="2n2331ffxhh4u">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-182" data-mp="mz1xui3b5iw5">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-183" data-mp="ixqgezul83z1">
                <Stars data-id="element-184" data-mp="iyrpiys1mge4" />
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-185" data-mp="ivnhtrfdd2ip">“{quote}”</p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-186" data-mp="16msuxytxdgpb">
      <div className="mx-auto max-w-5xl" data-id="element-187" data-mp="11nybqvs1pq4o">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-188" data-mp="11mws42wyrvbc">
          LO QUE DICEN QUIENES YA LO ESTÁN APLICANDO
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-189" data-mp="1aow9wxfsz3fc">
          {extendedTestimonials.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-190" data-mp="3heawc2zjt2kr">
              <Stars data-id="element-191" data-mp="3cgj2h3fcf6dx" />
              <p className="mt-2 font-bold" data-id="element-192" data-mp="3ch2k0j12zsrf">
                {name} <span className="font-normal text-slate-400" data-id="element-193" data-mp="3cidl2b356meu">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-194" data-mp="1s0b8xtr397gf">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}